export default {
  Textbox: {
    Placeholder: 'Add item or type / to invoke a skill...',
    Loading: 'Loading skills...',
    NoMatch: 'No playbooks or skills match that command.',
  },
  Response: {
    QueuedForApproval: 'QUEUED FOR APPROVAL',
  },
  Email: {
    Draft: 'email.draft',
    Fields: {
      To: 'To',
      FromName: 'From Name',
      From: 'From',
      Subject: 'Subject',
    },
    Actions: {
      ApproveAndSend: 'Approve & send',
      Regenerate: 'Regenerate',
      Discard: 'Discard',
    },
  },
  Sms: {
    Draft: 'sms.draft',
    Fields: {
      To: 'To',
      From: 'From',
    },
    Actions: {
      ApproveAndSend: 'Approve & send',
      Regenerate: 'Regenerate',
      Discard: 'Discard',
    },
  },
  Text: {
    Draft: 'text.draft',
    Actions: {
      Regenerate: 'Regenerate',
      Discard: 'Discard',
    },
  },
  Careplan: {
    Actions: {
      Save: 'Approve & Save',
      Regenerate: 'Regenerate',
      Discard: 'Discard',
    },
  },
};
